import { render, staticRenderFns } from "./VariantOptions.vue?vue&type=template&id=8f1de400&"
import script from "./VariantOptions.vue?vue&type=script&lang=ts&"
export * from "./VariantOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports